export var CardIssuer;
(function (CardIssuer) {
    CardIssuer["KTC"] = "KTC";
    CardIssuer["UOB"] = "UOB";
})(CardIssuer || (CardIssuer = {}));
//# sourceMappingURL=card-issuer.enum.js.map